import { useEffect, useState } from "react";

export const useHelpScout = () => {
  const [isBeaconReady, setIsBeaconReady] = useState(false);

  useEffect(() => {
    const checkBeacon = () => {
      if (window.Beacon && typeof window.Beacon === "function") {
        setIsBeaconReady(true);
      }
    };

    checkBeacon();

    const interval = setInterval(() => {
      checkBeacon();
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  const openBeacon = () => {
    if (window.Beacon) {
      window.Beacon("open");
    }
  };

  const closeBeacon = () => {
    if (window.Beacon) {
      window.Beacon("close");
    }
  };

  const toggleBeacon = () => {
    if (window.Beacon) {
      window.Beacon("toggle");
    }
  };

  const identifyUser = (userData: {
    name?: string;
    email?: string;
    userId?: string;
  }) => {
    if (window.Beacon) {
      window.Beacon("identify", {
        ...(userData.name && { name: userData.name }),
        ...(userData.email && { email: userData.email }),
        ...(userData.userId && { userId: userData.userId }),
      });
    }
  };

  return {
    isBeaconReady,
    openBeacon,
    closeBeacon,
    toggleBeacon,
    identifyUser,
  };
};
